"use client"
import Footer from '../components/Footer';
import PreHeader from '../components/PreHeader';
import Header from '../components/Header';
import Menu from '../components/Menu';
import { ProductProvider } from '../components/Productcontext';
import ScrollToTopButton from '../components/ScrollToTopButton';
import banner1 from '../images/faq/faq_banner.jpg';
import banner1_360 from '../images/faq/faq_banner_360.jpg';
import banner1_tab from '../images/faq/faq_banner_tab.jpg';
import banner1_2x from '../images/faq/faq_banner@2x.jpg';
import FaqContentnewv2 from '../components/FaqContentnewv2';
import FaqBanner from '../components/FaqBanner';
import React, { useState} from 'react';
export default function FaqPage() {
    const [isSticky, setSticky] = useState(true);
    const displline =true;  
    return (
        <div>
            {/* <PreHeader/>
            <Header isSticky={isSticky}/>
            <Menu isHeaderVisible={isSticky}/> */}
            <FaqBanner page="Faq" banalt="FAQ section banner for Ashlok Safe Earthing Electrode Limited" bannertext="" ban1x={banner1} ban2x={banner1_2x} ban360={banner1_360} bantab={banner1_tab}/>
            <FaqContentnewv2/>
            <ScrollToTopButton/>
            <ProductProvider>
                <Footer linedisp="true"/>
            </ProductProvider>
        </div>
    )

}